/**
 * @packageDocumentation
 * @module      EmcFaultCounts.ts
 * @description Holds the existing fault and warning counts for EMC subsystems.
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
export default class EmcFaultCounts {
    constructor() {
        this.psArm = { warnings: 0, faults: 0 };
        this.psDrive = { warnings: 0, faults: 0 };
        this.psFrame = { warnings: 0, faults: 0 };
        this.psRc = { warnings: 0, faults: 0 };
        this.psIc = { warnings: 0, faults: 0 };
        this.psUi = { warnings: 0, faults: 0 };
        this.psSc = { warnings: 0, faults: 0 };
        this.csRc = { warnings: 0, faults: 0 };
        this.csIc = { warnings: 0, faults: 0 };
        this.csUi = { warnings: 0, faults: 0 };
        this.csSc = { warnings: 0, faults: 0 };
        this.csPim = { warnings: 0, faults: 0 };
    }
    static fromJson(json) {
        let data = new EmcFaultCounts();
        if (json && json.FaultCounts) {
            let faultCountsJson = json.FaultCounts;
            data.psArm = { warnings: faultCountsJson.PSArm[0], faults: faultCountsJson.PSArm[1] };
            data.psDrive = { warnings: faultCountsJson.PSDrive[0], faults: faultCountsJson.PSDrive[1] };
            data.psFrame = { warnings: faultCountsJson.PSFrame[0], faults: faultCountsJson.PSFrame[1] };
            data.psRc = { warnings: faultCountsJson.PSRC[0], faults: faultCountsJson.PSRC[1] };
            data.psIc = { warnings: faultCountsJson.PSIC[0], faults: faultCountsJson.PSIC[1] };
            data.psUi = { warnings: faultCountsJson.PSUI[0], faults: faultCountsJson.PSUI[1] };
            data.psSc = { warnings: faultCountsJson.PSSC[0], faults: faultCountsJson.PSSC[1] };
            data.csRc = { warnings: faultCountsJson.CSRC[0], faults: faultCountsJson.CSRC[1] };
            data.csIc = { warnings: faultCountsJson.CSIC[0], faults: faultCountsJson.CSIC[1] };
            data.csUi = { warnings: faultCountsJson.CSUI[0], faults: faultCountsJson.CSUI[1] };
            data.csSc = { warnings: faultCountsJson.CSSC[0], faults: faultCountsJson.CSSC[1] };
            data.csPim = { warnings: faultCountsJson.CSPIM[0], faults: faultCountsJson.CSPIM[1] };
        }
        return data;
    }
}
//# sourceMappingURL=EmcFaultCounts.js.map